export class ActionResult {
    message: string;
    title: string;
    alertType: string;
}